import { ImageFileIcon, ImageFileIconProps } from "../ImageFileIcon"

export const LightMapIcon = ({ containerClasses, iconSize }: ImageFileIconProps) => {
    return (
        <ImageFileIcon
            id="light-map-icon"
            imageFilePath="/images/maps/light.jpg"
            containerClasses={containerClasses}
            iconSize={iconSize}
        />
    )
}

export default LightMapIcon
